export const COOKIE = {
    NAME: 'udid',
    INTERVAL_24: 24 * 60 * 60 * 1000, // 24 hodin
    EXPIRACY_DAYS: 30,
    REFRESH_DAYS: 20,
};
export const RANDOM_ID_LENGTH = 32;
export const DEBUG_CONFIG = {
    name: 'MRKR',
    bColor: '#e6b800',
    fColor: '#fff',
};
export const STATES = {
    START: 'start',
    DONE: 'done',
    ERROR: 'error',
};
export const EVENT_NAME = 'szn:marker:cookie';
